import type { SupportContact } from './types'

const DEFAULT_SUPPORT_PHONE = '949-989-4906'
const DEFAULT_SUPPORT_EMAIL = 'employee.experience@sureco.com'

export const phoneDigits = (phone: string): string => phone.replace(/\D/g, '')

export const SUPPORT_CONTACT_PENDING = '—'

export type ResolvedSupportContact = {
  phone: string
  email: string
  phoneDigits: string
  showIvrPrompt: boolean
}

export const pendingSupportContact = (): ResolvedSupportContact => ({
  phone: SUPPORT_CONTACT_PENDING,
  email: SUPPORT_CONTACT_PENDING,
  phoneDigits: '',
  showIvrPrompt: false,
})

const nonBlank = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim()
  return trimmed || undefined
}

export const resolveSupportContact = (
  value: SupportContact | null | undefined
): ResolvedSupportContact => {
  const phone = nonBlank(value?.phone) ?? DEFAULT_SUPPORT_PHONE
  const email = nonBlank(value?.email) ?? DEFAULT_SUPPORT_EMAIL
  const digits = phoneDigits(phone)

  return {
    phone,
    email,
    phoneDigits: digits,
    showIvrPrompt: digits === phoneDigits(DEFAULT_SUPPORT_PHONE),
  }
}
